import {
  assert,
  messages,
  reportError,
} from '@wix/editor-elements-corvid-utils';
import type { ILoginSocialBarSDK } from '../LoginSocialBar.types';

export const validateNavBarItems = (
  value: ILoginSocialBarSDK['navBarItems'],
) => {
  let isValid = true;
  if (assert.isArray(value)) {
    value.forEach(({ icon }, index) => {
      if (!assert.isSVG(icon)) {
        isValid = false;
        reportError(
          messages.invalidMenuItemMessage({
            propertyName: 'navBarItems',
            value: icon,
            index,
          }),
        );
      }
    });
  }
  return isValid;
};
